/**
 * ═══ COMBIEN DE PHOTOS DE FRONT ═══
 *
 * L'organisateur choisit le nombre de colonnes de la grille sur bureau
 * (`FO_MEETING_V2_ALB_COLUMNS`, 4 par défaut, comme la maquette). Le mobile n'a pas
 * de réglage à lui : il en prend la MOITIÉ, arrondie au-dessus — deux colonnes pour
 * quatre, comme aujourd'hui, trois pour six — parce qu'une vignette de 60 px sur un
 * téléphone ne se regarde plus, et qu'un second réglage pour le dire serait un de trop.
 *
 * ⚠️ BORNÉ. Une valeur absurde (0, 40, « abc ») ne casse pas la grille : elle retombe
 * sur le défaut, ou sur la borne la plus proche. Le panneau enregistre un nombre
 * (voir `panel/Row.tsx`), une valeur reprise de la V1 peut être une chaîne : on lit
 * les deux.
 */

export const ALBUM_COLUMNS_DEFAULT = 4;
export const ALBUM_COLUMNS_MIN = 1;
export const ALBUM_COLUMNS_MAX = 8;

export type AlbumColumns = { desktop: number; mobile: number };

export function albumColumns(raw: unknown): AlbumColumns {
  const n =
    typeof raw === "number"
      ? raw
      : typeof raw === "string" && raw.trim() !== ""
        ? Number(raw)
        : NaN;
  const desktop = Number.isFinite(n)
    ? Math.min(ALBUM_COLUMNS_MAX, Math.max(ALBUM_COLUMNS_MIN, Math.round(n)))
    : ALBUM_COLUMNS_DEFAULT;
  return { desktop, mobile: Math.max(1, Math.ceil(desktop / 2)) };
}
